import type { AppRouter } from "@/server/routes/trpc/_app";
import { TRPCClientError } from "@trpc/client";
import {
  createTRPCClient,
  httpBatchLink,
  splitLink,
  unstable_httpSubscriptionLink
} from "@trpc/client";
import superjson from "superjson";
import { toast } from "svoast";
import ErrorToast from "@/components/results/error-toast.svelte";

export function isTRPCClientError(
  cause: unknown
): cause is TRPCClientError<AppRouter> {
  return cause instanceof TRPCClientError;
}

const url = import.meta.env.SSR
  ? "http://localhost" //Just as placeholder for SSR
  : `${document.location.origin}/trpc`;

export const client = createTRPCClient<AppRouter>({
  links: [
    // call subscriptions through websockets and the rest over http
    splitLink({
      condition(op) {
        return op.type === "subscription";
      },
      true: unstable_httpSubscriptionLink({
        url: url,
        transformer: superjson
      }),
      false: httpBatchLink({
        url,
        transformer: superjson
      })
    })
  ]
});

export const trpcTryCatch = async <T>(fn: () => Promise<T>) => {
  try {
    await fn();
  } catch (e) {
    toast.error("Error", {
      component: [ErrorToast, { errorsInfo: getTRPCErrors(e).join("<br/>") }]
    });
  }
};

export const getTRPCErrors = (error: any) => {
  if (isTRPCClientError(error)) {
    if (error.data?.type === "ZodError") {
      return (
        error.data.zodError?.map((e) => `<b>${e.path[0]}</b> ${e.message}`) ??
        []
      );
    }
    return [error.message];
  } else {
    return [error as string];
  }
};
